<template>
	<div>
		<v-btn color="primary" @click="$emit('continue')">{{
			$localize('ArticleImport.newImport')
		}}</v-btn>

		<v-data-table
			:items="articleImports"
			:headers="articleImportsHeaders"
			@click:row="navArticleImport"
		>
			<template v-slot:[`item.isConfirmed`]="{ item }">
				<v-icon v-if="!item.isConfirmed">mdi-pencil</v-icon>
				<v-icon v-else-if="item.processedRows == item.totalDataRows"
					>mdi-check</v-icon
				>
				<v-icon v-else>mdi-sync</v-icon>
			</template>
			<template v-slot:[`item.created`]="{ item }">{{
				$format.shortDateTime(item.created)
			}}</template>
			<template v-slot:[`item.failedRows`]="{ item }">{{
				item.failedRows ? item.failedRows.length : 0
			}}</template>
			<template v-slot:[`item.actions`]="{ item }">
				<v-btn
					small
					color="error"
					@click.native.stop="
						deleteArticleImportId = item.articleImportId
						deleteArticleImport = true
					"
				>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</template>
		</v-data-table>
		<delete-article-import
			v-if="deleteArticleImport"
			v-model="deleteArticleImport"
			:article-import-id="deleteArticleImportId"
			@saved="refresh()"
		/>
	</div>
</template>

<script>
import DeleteArticleImport from '../dialogs/DeleteArticleImport'
import { getAllArticleImports } from '@/services/api'

export default {
	components: { DeleteArticleImport },
	props: {
		value: String,
	},
	data() {
		return {
			deleteArticleImport: false,
			deleteArticleImportId: null,

			articleImports: [],
			articleImportsHeaders: [
				{
					value: 'isConfirmed',
					width: 48,
				},
				{
					text: this.$localize('ArticleImport.originalFileName'),
					value: 'originalFileName',
				},
				{
					text: this.$localize('ArticleImport.created'),
					value: 'created',
				},
				{
					text: this.$localize('ArticleImport.totalRows'),
					value: 'totalDataRows',
				},
				{
					text: this.$localize('ArticleImport.rowsProcessed'),
					value: 'processedRows',
				},
				{
					text: this.$localize('ArticleImport.rowsFailed'),
					value: 'failedRows',
				},
				{
					text: this.$localize('ArticleImport.actions'),
					value: 'actions',
				},
			],
		}
	},
	created() {
		this.refresh()
	},
	methods: {
		async refresh() {
			const { result, ok } = await getAllArticleImports.call()
			if (ok) {
				this.articleImports = result
			}
		},
		navArticleImport(articleImport) {
			this.$router.push({
				name: 'articleImport',
				params: { articleImportId: articleImport.articleImportId },
			})
		},
	},
}
</script>
